import { IconButton, Typography } from '@mui/material';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import SettingsIcon from '@mui/icons-material/Settings';
import { Tooltip } from "@mui/material";
import { useTheme } from '@emotion/react';
import { UseFormReturn } from 'react-hook-form';
import { DocumentAdd, DocumentEdit } from '../../../../models/document';
import { useLocation, useNavigate } from "react-router-dom";
import { ItemsFormType, PaymentsFormType, WorksFormType } from '../../pages/add-document/AddDocument.types';
import { DocumentSettings } from '../../../../models/document-settings';


interface TitleProps {

    method: "add" | "edit";

    documentForm: UseFormReturn<DocumentAdd> | UseFormReturn<DocumentEdit>;
    worksForm: UseFormReturn<WorksFormType>
    itemsForm: UseFormReturn<ItemsFormType>
    paymentsForm: UseFormReturn<PaymentsFormType>

    settings: DocumentSettings;
    isDocumentClosed?: boolean;

}

function Title({ method, documentForm, worksForm, itemsForm, paymentsForm, settings, isDocumentClosed }: TitleProps) {

    const navigate = useNavigate();
    const { state, pathname } = useLocation();
    const theme = useTheme();

    function createState(){
        return {
            ...state,
            from: pathname,
            document_settings_id: settings?.id,

            document_account: documentForm.getValues().document_account,
            car: documentForm.getValues().car,

            works: worksForm.getValues().works,
            items: itemsForm.getValues().items,
            payments: paymentsForm.getValues().payments,
            reference: documentForm.getValues().reference,
            custom_data: documentForm.getValues().custom_data,

        }
    }

    
    // *********************************************************************************************

    
    function createBreadcrumbData(state: any){

        const thisPageLink = 'id' in documentForm.getValues() ?
            `/documents/${(documentForm as  UseFormReturn<DocumentEdit>).getValues("id")}` :
            `/documents/add?documentType=${settings?.id}`;

        return [
            {
                name: "מסמכים",
                link: "/documents",
            },
            {
                name: "הוספת מסמך",
            },
            {
                name: `${settings?.name}`,
                link: thisPageLink,
                state: state
            },
        ];
    }

    // *********************************************************************************************


    //navigate to document browsing
    function browseDocument() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/documents`, {
            replace: true,
            state: {
                ...currentState,
                method: "browse document",
                breadcrumbData: [...breadcrumbData, { name: "בחירת מסמך" }]
            }
        });

    }


    // *********************************************************************************************


    //navigate to document (reference) browsing
    function browseReference() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/documents`, {
            replace: true,
            state: {
                ...currentState,
                method: "reference",
                breadcrumbData: [...breadcrumbData, { name: "צירוף אסמכתא" }]
            }
        });

    }


    // *********************************************************************************************


    function editDocumentSettings() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/documents/settings/${settings?.id}`, {
            replace: true,
            state: {
                ...currentState,
                breadcrumbData: [...breadcrumbData, { name: "הגדרות מסמך" }]
            }
        });
    }

    if (method === "add") {

        documentForm = documentForm as UseFormReturn<DocumentAdd>;

        return (
            <div className="title">
                <div>
                    <Typography variant="h5" component={'span'} >
                        הוספת מסמך
                    </Typography>
                    <Tooltip title="טעינה של מסמך קיים מתוך דפדוף">
                        <IconButton onClick={browseDocument} sx={{ color: theme.colors.main_color }}>
                            <AutoStoriesIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="צירוף אסמכתא">
                        <IconButton onClick={browseReference} sx={{ color: theme.colors.main_color }}>
                            <FilePresentIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="הגדרות מסמך">
                        <IconButton onClick={editDocumentSettings} sx={{ color: theme.colors.main_color }}>
                            <SettingsIcon />
                        </IconButton>
                    </Tooltip>
                    {/* <button onClick={documentSettings}>הגדרות מסמך</button> */}
                </div>
                <div>
                    {/* אסמכתא: כרטיס עבודה 1 */}
                    {documentForm.getValues("reference") ? `אסמכתא:  ${documentForm.getValues("reference")}` : ""}
                </div>

            </div>
        )
    }

    else if (method === "edit") {

        documentForm = documentForm as UseFormReturn<DocumentEdit>;

        return (
            <div className={`title ${isDocumentClosed? "disabled" : ""}`}>
                <div>
                    <Typography variant="h5" component={'span'} >
                        עריכת מסמך
                    </Typography>
                    <Tooltip title="טעינה של מסמך קיים מתוך דפדוף">
                        <span>
                            <IconButton onClick={browseDocument} sx={{ color: theme.colors.main_color }} disabled={isDocumentClosed}>
                                <AutoStoriesIcon />
                            </IconButton>
                        </span>

                    </Tooltip>
                    <Tooltip title="צירוף אסמכתא">
                        <span>
                            <IconButton onClick={browseReference} sx={{ color: theme.colors.main_color }} disabled={isDocumentClosed}>
                                <FilePresentIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="הגדרות מסמך">
                        <IconButton onClick={editDocumentSettings} sx={{ color: isDocumentClosed? "rgba(0,0,0,0.3)" : theme.colors.main_color }}>
                            <SettingsIcon />
                        </IconButton>
                    </Tooltip>
                    {/* <button onClick={documentSettings}>הגדרות מסמך</button> */}
                </div>
                <div>
                    {/* אסמכתא: כרטיס עבודה 1 */}
                    {documentForm.getValues("reference") ? `אסמכתא:  ${documentForm.getValues("reference")}` : ""}
                </div>

            </div>
        )
    }

}

export default Title